import TripAvailabilityItem from './trip-availability-item-component';

const MODULE_NAME = 'app.trip.availability-item';
const module = angular.module(MODULE_NAME, [])
    .directive(TripAvailabilityItem.DIRECTIVE_NAME, TripAvailabilityItem);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-availability-item/trip-availability-item-module.js